import { CapoPlugin } from "/builds/webcontact/engelsbrand/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];